import { z } from 'zod';
// ----------------------------------------------------------------------------
//  Response
// ----------------------------------------------------------------------------
const HouseCountsSchema = z
    .object({
    physicalCount: z.number().optional(),
    houseCount: z.number().optional(),
    soldCount: z.number().optional(),
    occupancy: z.number().optional(),
    availableCount: z.number().optional(),
    sellableCount: z.number().optional(),
    allowedOverbookingCount: z.number().optional()
})
    .passthrough();
const RestrictionsSchema = z
    .object({
    minLengthOfStay: z.number().optional(),
    maxLengthOfStay: z.number().optional(),
    closed: z.boolean().optional(),
    closedOnArrival: z.boolean().optional(),
    closedOnDeparture: z.boolean().optional()
})
    .passthrough();
const PriceSchema = z
    .object({
    adults: z.number().optional(),
    price: z
        .object({
        grossAmount: z.number().optional(),
        currency: z.string().optional()
    })
        .passthrough()
        .optional()
})
    .passthrough();
const RatePlanDaySchema = z.object({
    ratePlanId: z.string(),
    available: z.number().nullable(),
    availableUnits: z.number().nullable(),
    restrictions: RestrictionsSchema.nullable(),
    prices: z.array(PriceSchema)
});
const UnitGroupDaySchema = z.object({
    unitGroupId: z.string(),
    unitGroupName: z.string().optional(),
    unitGroupType: z.string().optional(),
    house: HouseCountsSchema.nullable(),
    ratePlans: z.array(RatePlanDaySchema)
});
const AvailabilityDaySchema = z.object({
    date: z.string(),
    unitGroups: z.array(UnitGroupDaySchema)
});
export const AvailabilityIndexResultSchema = z.object({
    propertyId: z.string(),
    from: z.string(),
    to: z.string(),
    days: z.array(AvailabilityDaySchema)
});
